// cfgmenus

import http from '../../../store/api/http' 

const actions = {
    getCfgMenus(context, param) {
		return new Promise((resolve, reject) => {
			http.get('/api/cfgmenus')
			.then(function (response) {
		    	context.commit('getCfgMenus', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateCfgMenus(context, data) {
		return new Promise((resolve, reject) => {
			http.post('/api/cfgmenus', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },

};

export default actions;